module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "turnovertype-new"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/master"
    }
  }, [_vm._v(_vm._s(_vm.$t('Master Manage')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/turnover_types"
    }
  }, [_vm._v(_vm._s(_vm.$t('Turnover Type List')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Turnover Type New')))])])]), _c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('Turnover Type New')))]), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('turnover.list.Group')))]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.turnovertypes.turnover_class),
      expression: "turnovertypes.turnover_class"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.turnover_class
    },
    on: {
      "change": function($event) {
        _vm.turnovertypes.turnover_class = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', [_vm._v(_vm._s(_vm.$t('turnover_class.class1')))]), _c('option', [_vm._v(_vm._s(_vm.$t('turnover_class.class2')))]), _c('option', [_vm._v(_vm._s(_vm.$t('turnover_class.class3')))]), _c('option', [_vm._v(_vm._s(_vm.$t('turnover_class.class4')))]), _c('option', [_vm._v(_vm._s(_vm.$t('turnover_class.class5')))]), _c('option', [_vm._v(_vm._s(_vm.$t('turnover_class.class6')))])])]), _c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('turnover.list.Content')))]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.turnovertypes.turnover_content),
      expression: "turnovertypes.turnover_content"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.turnover_content
    },
    attrs: {
      "type": "text",
      "maxlength": "50"
    },
    domProps: {
      "value": _vm._s(_vm.turnovertypes.turnover_content)
    },
    on: {
      "keyup": _vm.half,
      "touchend": _vm.half,
      "change": _vm.half,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.turnovertypes.turnover_content = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.turnover_content),
      expression: "!validation.turnover_content"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('a', {
    staticClass: "btn btn-info",
    class: {
      disabled: !_vm.validation.not_input
    },
    staticStyle: {
      "margin-right": "5px"
    },
    on: {
      "click": function($event) {
        _vm.onClickSave()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Save')))])]), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.onClickCancel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Cancel')))])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-294b470f!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/turnovertype-new.pug
// module id = 814
// module chunks = 1